import { render } from "./Join.vue?vue&type=template&id=16377bbe&scoped=true&ts=true"
import script from "./Join.vue?vue&type=script&lang=ts"
export * from "./Join.vue?vue&type=script&lang=ts"

import "./Join.vue?vue&type=style&index=0&id=16377bbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16377bbe"]])

export default __exports__